import { useEffect, useState } from 'react';

import { useDrawingManagerContext } from '../context/drawing-manager-context.js';
import { formatPositionForGrid } from './grid-utils.js';

import type { SelectionPoint } from '@cadstrom/renderer';
import type { ModelGrid } from '@cadstrom/sigma-engine-shared';

export type GridPositionProps = {
	grid: ModelGrid;
};

export function GridPosition({ grid }: GridPositionProps) {
	const { drawingManager } = useDrawingManagerContext();
	const [position, setPosition] = useState<PointString>();

	useEffect(() => {
		if (!drawingManager) {
			return;
		}

		const handleMove = (point: SelectionPoint) => {
			const position = formatPositionForGrid(point.drawingCoords(), {
				distance: grid.distance,
				units: grid.units,
				multiple: grid.multiple,
				invertX: grid.invertX,
				invertY: grid.invertY,
			});
			if (position) {
				setPosition(position);
			}
		};

		drawingManager.on('mouseMove', handleMove);
		return () => {
			drawingManager.removeListener('mouseMove', handleMove);
		};
	}, [drawingManager, grid.distance, grid.invertX, grid.invertY, grid.multiple, grid.units]);

	if (!position) {
		return <div />; // Empty div to maintain the space in the grid
	}

	return (
		<p className='w-26 text-sm whitespace-nowrap text-gray-a11'>
			({position.x}, {position.y})
		</p>
	);
}

interface PointString {
	x: string;
	y: string;
}
